var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"compare-visualization",attrs:{"element-loading-spinner":"presupuesto-loader"}},[_c(_vm.chartComponent,{tag:"component",attrs:{"data":_vm.data,"dimensions":_vm.dimensions}})],1)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a92b9730","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/Components/Visualizations/Compare.vue
// module id = 351
// module chunks = 0